export const INVOICE_ENTRY_TYPE = {
  api: 1,
  excel: 2,
  sql: 4,
  classicPos: 5,
  apiV2: 6,
  webFormFull: 7,
  webFormSimple: 8,
  webFormCostPrice: 9,
  webFormAdvancedCostPrice: 10,
  automaticInvoice: 11,
} as const

export interface InvoiceAutoSendSetting {
  entryType: number
  code: string
  title: string
  description: string
  autoSend: boolean
}

export const getWebFormEntryType = (formType: number) => {
  switch (formType) {
    case 1:
      return INVOICE_ENTRY_TYPE.webFormSimple
    case 2:
      return INVOICE_ENTRY_TYPE.webFormCostPrice
    case 3:
      return INVOICE_ENTRY_TYPE.webFormAdvancedCostPrice
    case 4:
      return INVOICE_ENTRY_TYPE.automaticInvoice
    default:
      return INVOICE_ENTRY_TYPE.webFormFull
  }
}

export const resolveInvoiceAutoSendDefault = (
  settings: InvoiceAutoSendSetting[] | undefined,
  entryType: number
) => settings?.find((setting) => setting.entryType === entryType)?.autoSend

export const resolveInvoiceAutoSendControlValue = (
  defaultValue: boolean | undefined,
  currentValue: boolean,
  touched: boolean
) => (!touched && defaultValue !== undefined ? defaultValue : currentValue)
